exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".liveroom .tooltip.for-profile > .tooltip-pointer {\n  left: auto;\n  right: 40px;\n}\n.tooltip.top.for-share > .tooltip-pointer {\n  left: auto;\n  right: 24px;\n}\n", ""]);

